module.exports = __webpack_public_path__ + "assets/img/contact_big_ft.456c092e.png";